/**
 * Which months the service-history grids draw.
 *
 * Shared by both sub-tabs so switching between maintenance visits and callbacks keeps
 * the axis where it was, rather than silently moving it under the reader.
 */
export const ROLLING_WINDOW = 'last12';

export type PeriodWindow = typeof ROLLING_WINDOW | `${number}`;

const YEARS_OFFERED = 4;

// Complete years only: a period that has not lapsed has nothing to answer for yet.
export const periodWindowOptions = (
  today: Date = new Date(),
): { value: PeriodWindow; label: string }[] => {
  const lastCompleteYear = today.getFullYear() - 1;
  return [
    { value: ROLLING_WINDOW, label: 'Last 12 months' },
    ...Array.from({ length: YEARS_OFFERED }, (_, index) => {
      const year = lastCompleteYear - index;
      return { value: `${year}` as PeriodWindow, label: `${year}` };
    }),
  ];
};

export interface PeriodWindowRange {
  start_date?: string;
  end_date?: string;
}

// The rolling window sends no dates and lets the API apply its own default, so
// "last twelve months" is defined in one place rather than two that can drift.
export const periodWindowRange = (window: PeriodWindow): PeriodWindowRange =>
  window === ROLLING_WINDOW ? {} : { start_date: `${window}-01-01`, end_date: `${window}-12-31` };

export const isPeriodWindow = (
  value: string | null,
  today: Date = new Date(),
): value is PeriodWindow =>
  value !== null && periodWindowOptions(today).some((option) => option.value === value);

// Still `visitsWindow` in the URL. The param predates the callbacks sub-tab and
// links carrying it are already out there; renaming it would break them for the sake
// of tidiness.
export const periodWindowParam = 'visitsWindow';
